import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { ValidationContainer } from './validation-container';

export const ValidationRules = ({
  validationRulesStruct,
}) => (
  _.map(validationRulesStruct, validationRuleStruct => (
    <ValidationContainer key={validationRuleStruct.name} rule={validationRuleStruct.name}>
      { validationRuleStruct.component }
    </ValidationContainer>
  ))
);

ValidationRules.propTypes = {
  validationRulesStruct: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    component: PropTypes.node.isRequired,
  })).isRequired,
};
